import React from 'react';
import { Modal } from 'antd';
import UserInfo from '../UserInfo/UserInfo';
import { useTranslation } from 'react-i18next';

const UserViewModal = ({
    modalVisible,
    handleCancel,
    user,
    screens
}) => {
    const { t } = useTranslation();
    return (
        <Modal
            key={modalVisible}
            title={t('user_information')}
            open={modalVisible}
            onCancel={handleCancel}
            destroyOnClose
            footer={null}
            width={screens.xs ? '100%' : 820}
            style={screens.xs ? { top: 0, padding: 0 } : {}}
        >
            <UserInfo user={user} />
        </Modal>
    );
};

export default UserViewModal;
